/* eslint-disable */
import React, { useContext, useEffect } from 'react';
import Modal from 'modules/common/components/Modal';
import { withRouter } from 'react-router-dom';
import { ModalContext } from 'App';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import withForm from 'modules/common/hoc/withForm';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  createInput,
  barangayInfo,
  selected,
  updating,
  formData,
  setFormData,
  showBarangay,
  updateBarangay
}) {
  const setModal = useContext(ModalContext);
  
  const OnSetFormData = () => {
    setFormData({
        zip_code: _.get(barangayInfo, 'zip_code') || ''
    });
  };

  useEffect(() => {
    if (!_.isEmpty(barangayInfo)) {
      OnSetFormData();
    }
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnUpdateModal = (e) => {
    e.preventDefault();
    
    updateBarangay(selected, formData, () => {
        showBarangay(selected);
        setModal({ isOpen: false });
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnUpdateModal}>
        <div className="row">
          <div className="col-12 form-grousp">
            {createInput(
              { key: 'zip_code', label: 'Zip Code' },
              { required: true, placeholder: 'Input Zip Code' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  ml-3 ">
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  barangayInfo: PropTypes.instanceOf(Object).isRequired,
  selected: PropTypes.string.isRequired,
  showBarangay: PropTypes.instanceOf(Function).isRequired,
  updateBarangay: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: _.get(api, 'loading', []).indexOf(c.UPDATE_BARANGAY) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
